export const DEVICE_ALERT_TEMPLATE = {
  hasValve: true,
  valveCount: 2,
  transducerCount: 3,
  transducerSides: ["v1", "v2"],
};
